/**
 * Labstep
 *
 * @module grid/Index/components/ToolPanel/Columns/Section
 * @desc Entity DataGrid column options section for shown/hidden fields
 */

import { Header } from 'labstep-web/core/Header';
import { Sortable } from 'labstep-web/core/Sortable';
import { GridIndexToolPanelColumnsSectionItem } from 'labstep-web/grid/Index/components/ToolPanel/Columns/Section/Item';
import { SectionType } from 'labstep-web/grid/services/grid.service';
import type React from 'react';
import { useMemo } from 'react';
import type {
  ColumnWithId,
  GridIndexToolPanelColumnsSectionProps,
} from './types';
import { columnsToItems, onSortEndColumns } from './utils';

export const GridIndexToolPanelColumnsSection: React.FC<
  GridIndexToolPanelColumnsSectionProps
> = ({ columns, section, onToggleColumnVisible, onSortColumns }) => {
  if (!columns.length) {
    return null;
  }
  const items: { id: string; column: ColumnWithId }[] = useMemo(
    () => columnsToItems(columns),
    [columns],
  );

  const onSortEnd: Parameters<typeof Sortable>[0]['onSortEnd'] =
    useMemo(
      () => onSortEndColumns(items, onSortColumns),
      [items, onSortColumns],
    );

  return (
    <div>
      <Header size="mini">{`${
        section === SectionType.hidden ? 'Hidden' : 'Shown'
      } fields`}</Header>
      <Sortable
        /** dnd-kit transform does not work with overlay in this case */
        hideOverlay
        items={items}
        onSortEnd={onSortEnd}
        renderItem={({ column }): JSX.Element => (
          <GridIndexToolPanelColumnsSectionItem
            column={column}
            section={section}
            onToggleColumnVisible={onToggleColumnVisible}
          />
        )}
      />
    </div>
  );
};
